import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'contents',
  },
  dialogContent: {
    display: 'flex',
    height: 'calc(85vh - 130px)',
    overflow: 'hidden',
  },
  fullPageContent: {
    display: 'flex',
    height: 'calc(100vh - 180px)',
    overflow: 'hidden',
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
